import LockIcon from "@mui/icons-material/Lock"

const RestrictedChart = ({ title }) => {
	return (
		<section className="scout-panel scout-panel--content scout-graphics-panel">
			<div className="scout-panel__heading scout-graphics-panel__heading">
				<h2>{title}</h2>
				<LockIcon />
			</div>
			<div className="scout-graphics-panel__body scout-graphics-panel__body--empty">
				<div className="scout-graphics-empty-state">
					Recurso indisponível no seu plano.
				</div>
			</div>
		</section>
	)
}

export default RestrictedChart
